//export default class Headline {
//   constructor() {  
//     this.$sections = document.querySelectorAll('section.headline');  
//   }
//}
//
//new Headline();

import AOS from 'aos';
import 'aos/dist/aos.css'; 

document.addEventListener("DOMContentLoaded", () => {
    AOS.init();
})
